export default __webpack_public_path__ + "static/media/Harsha_P_R.33f2921e.jpeg";